module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm"
  }, [_c('div', {
    staticClass: "box-bordered p-l-10 p-r-10 p-b-10"
  }, [_c('table', {
    staticClass: "table table-hover table-staff"
  }, [_c('tbody', [_vm._l((_vm.areas), function(area) {
    return [_c('tr', {
      staticClass: "area"
    }, [_c('td', {
      attrs: {
        "bgcolor": _vm.areaColors[area.area_name],
        "colspan": "3"
      }
    }, [_vm._v("Dział:" + _vm._s(area.area_name) + " (" + _vm._s(area.users.length) + ")")])]), _vm._v(" "), _vm._l((area.users), function(user) {
      return _c('tr', {
        staticClass: "staff"
      }, [_c('td', [_vm._v(_vm._s(user.surname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', [_c('a', {
        attrs: {
          "href": 'mailto:' + user.login + '@lekseek.com'
        }
      }, [_vm._v(_vm._s(user.login) + "@lekseek.com")])])])
    })]
  })], 2)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2b455ef8!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/ia/ActiveEmployees.vue
// module id = 1091
// module chunks = 0